function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M504.396,210.617h-27.174c-4.199,0-7.604,3.405-7.604,7.604v21.201h-12.365V218.22c0-4.199-3.405-7.604-7.604-7.604h-30.014 c-4.199,0-7.604,3.405-7.604,7.604v21.201h-12.365V218.22c0-4.199-3.405-7.604-7.604-7.604h-27.174 c-4.199,0-7.604,3.405-7.604,7.604v57.609v24.334h-20.587V184.589h18.595c2.495,0,4.92-1.105,6.373-3.133 c2.248-3.138,1.803-7.297-0.811-9.879l-97.251-96.108V59.888h62.735c2.256,0,4.468-0.891,5.945-2.598 c2.32-2.681,2.468-6.481,0.558-9.286l-12.295-18.061l12.295-18.061c1.91-2.805,1.762-6.605-0.558-9.286 C330.806,0.891,328.594,0,326.338,0H256c-4.199,0-7.604,3.405-7.604,7.604v44.68v23.185l-97.094,95.953 c-1.775,1.754-2.723,4.246-2.332,6.711c0.606,3.812,3.847,6.455,7.521,6.455h18.811v43.589c0,4.199,3.405,7.604,7.604,7.604l0,0 c4.199,0,7.604-3.405,7.604-7.604v-43.589H321.49v123.14c0,0.013-0.002,0.026-0.002,0.04v23.501H309.13v-23.501 c0-4.199-3.405-7.604-7.604-7.604h-31.745c-4.199,0-7.604,3.405-7.604,7.604v23.501h-12.359v-23.501 c0-4.199-3.405-7.604-7.604-7.604h-31.734c-4.199,0-7.604,3.405-7.604,7.604v23.501h-12.369v-23.501c0-0.001,0-0.002,0-0.002 l0.002-0.001v-44.101c0-4.199-3.405-7.604-7.604-7.604l0,0c-4.199,0-7.604,3.405-7.604,7.604v36.499h-20.587v-24.334v-57.609 c0-4.199-3.405-7.604-7.604-7.604h-27.174c-4.199,0-7.604,3.405-7.604,7.604v21.201H99.969v-21.201c0-4.199-3.405-7.604-7.604-7.604 H62.35c-4.199,0-7.604,3.405-7.604,7.604v21.201H42.381v-21.201c0-4.199-3.405-7.604-7.604-7.604H7.604 c-4.199,0-7.604,3.405-7.604,7.604v57.609c0,4.199,3.405,7.604,7.604,7.604h17.849v220.964c0,4.199,3.405,7.604,7.604,7.604H147.11 c0.007,0,0.013-0.001,0.019-0.001h217.74c0.006,0,0.013,0.001,0.019,0.001h114.054c4.199,0,7.604-3.405,7.604-7.604V363.019 c0-4.199-3.405-7.604-7.604-7.604l0,0c-4.199,0-7.604,3.405-7.604,7.604v133.773h-98.843V307.767c0-0.02-0.003-0.039-0.003-0.059 v-24.275h98.846v44.1c0,4.199,3.405,7.604,7.604,7.604l0,0c4.199,0,7.604-3.405,7.604-7.604v-44.1h17.849 c4.199,0,7.604-3.405,7.604-7.604V218.22C512,214.021,508.596,210.617,504.396,210.617z M305.061,34.223l7.118,10.457h-48.575 V15.208h48.576l-7.118,10.457C303.303,28.247,303.303,31.642,305.061,34.223z M182.906,169.381h-7.903L256,89.336l80.997,80.044 h-7.903H182.906z M15.208,225.824h11.966v21.201c0,4.199,3.405,7.604,7.604,7.604H62.35c4.199,0,7.604-3.405,7.604-7.604v-21.201 h14.806v21.201c0,4.199,3.405,7.604,7.604,7.604h27.573c4.199,0,7.604-3.405,7.604-7.604v-21.201h11.966v42.401H33.057H15.208 V225.824z M139.506,496.792H40.661V283.433h98.845V496.792z M154.719,315.371h20.581v23.501c0,4.199,3.405,7.604,7.604,7.604h27.577 c4.199,0,7.604-3.405,7.604-7.604v-23.501h16.526v23.501c0,4.199,3.405,7.604,7.604,7.604h27.567c4.2,0,7.604-3.405,7.604-7.604 v-23.501h16.537v23.501c0,4.199,3.404,7.604,7.604,7.604h27.566c4.2,0,7.604-3.405,7.604-7.604v-23.501h20.59v181.42H315.31v-67.37 c0-32.702-26.605-59.308-59.308-59.308l0,0c-32.702,0-59.308,26.606-59.308,59.308v67.37h-41.973v-181.42H154.719z M263.604,385.991 c20.704,3.615,36.496,21.708,36.496,43.431v66.912h-36.496V385.991z M248.396,496.333h-36.497v-66.912 c0-21.723,15.792-39.815,36.497-43.431V496.333z M496.792,268.225h-17.848h-106.45v-42.401h11.966v21.201 c0,4.199,3.404,7.604,7.604,7.604h27.573c4.2,0,7.604-3.405,7.604-7.604v-21.201h14.806v21.201c0,4.199,3.404,7.604,7.604,7.604 h27.573c4.2,0,7.604-3.405,7.604-7.604v-21.201h11.965V268.225z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.512,388.363h42.58c4.199,0,7.604-3.405,7.604-7.604v-45.622c0-15.932-12.962-28.894-28.894-28.894 s-28.894,12.962-28.894,28.894v45.622C58.908,384.958,62.313,388.363,66.512,388.363z M74.116,335.137 c0-7.546,6.14-13.686,13.686-13.686c7.546,0,13.686,6.14,13.686,13.686v38.018H74.116V335.137z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M448.212,335.137c0-15.932-12.961-28.894-28.894-28.894s-28.894,12.962-28.894,28.894v45.622 c0,4.199,3.404,7.604,7.604,7.604h42.58c4.2,0,7.604-3.405,7.604-7.604L448.212,335.137L448.212,335.137z M433.004,373.155h-27.372 v-38.018c0-7.546,6.14-13.686,13.686-13.686s13.686,6.14,13.686,13.686V373.155z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M227.106,271.775c0,4.199,3.405,7.604,7.604,7.604h42.581c4.2,0,7.604-3.405,7.604-7.604v-45.622 c0-15.932-12.961-28.894-28.894-28.894l0,0c-15.932,0-28.894,12.962-28.894,28.894v45.622H227.106z M242.314,226.153 c0-7.546,6.14-13.686,13.686-13.686c7.546,0,13.687,6.14,13.687,13.686v38.018h-27.372v-38.018H242.314z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.909,430.943h21.29c4.199,0,7.604-3.405,7.604-7.604c0-4.199-3.405-7.604-7.604-7.604h-21.29 c-4.199,0-7.604,3.405-7.604,7.604C51.305,427.538,54.709,430.943,58.909,430.943z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M104.53,440.067H83.241c-4.199,0-7.604,3.405-7.604,7.604c0,4.199,3.405,7.604,7.604,7.604h21.29 c4.199,0,7.604-3.405,7.604-7.604C112.135,443.471,108.73,440.067,104.53,440.067z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M422.36,423.339c0-4.199-3.404-7.604-7.604-7.604h-21.29c-4.2,0-7.604,3.405-7.604,7.604c0,4.199,3.404,7.604,7.604,7.604 h21.29C418.957,430.943,422.36,427.538,422.36,423.339z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M417.797,455.274h21.29c4.2,0,7.604-3.405,7.604-7.604c0-4.199-3.404-7.604-7.604-7.604h-21.29 c-4.2,0-7.604,3.405-7.604,7.604C410.193,451.87,413.598,455.274,417.797,455.274z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M318.951,385.321h21.29c4.2,0,7.604-3.405,7.604-7.604c0-4.199-3.404-7.604-7.604-7.604h-21.29 c-4.2,0-7.604,3.405-7.604,7.604C311.347,381.917,314.751,385.321,318.951,385.321z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M224.179,190.669h-21.29c-4.199,0-7.604,3.405-7.604,7.604c0,4.199,3.405,7.604,7.604,7.604h21.29 c4.199,0,7.604-3.405,7.604-7.604C231.783,194.073,228.378,190.669,224.179,190.669z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M198.815,395.966c0-4.199-3.405-7.604-7.604-7.604h-21.29c-4.199,0-7.604,3.405-7.604,7.604s3.405,7.604,7.604,7.604h21.29 C195.411,403.57,198.815,400.166,198.815,395.966z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

const SvgFortress = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#ED434B"
  },
  points: "326.555,52.284 256,52.284 256,7.604 326.555,7.604 311.346,29.944 "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#E7ECEF"
  },
  points: "182.906,377.717 182.906,176.985 329.094,176.985 329.094,377.717 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#D2D6D8"
  },
  points: "329.094,176.985 218.584,176.985 182.906,176.985 182.906,204.863 182.906,377.717  218.584,377.717 218.584,204.863 329.094,204.863 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#B8C1C8"
  },
  points: "388.9,307.767 388.9,504.395 115.178,504.395 115.178,307.767 182.904,307.767  182.904,338.872 210.481,338.872 210.481,307.767 242.215,307.767 242.215,338.872 269.782,338.872 269.782,307.767  301.525,307.767 301.525,338.872 329.093,338.872 329.093,307.767 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.057,
  y: 275.831,
  style: {
    fill: "#E7ECEF"
  },
  width: 114.049,
  height: 228.565
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#D2D6D8"
  },
  points: "147.11,275.829 66.512,275.829 33.057,275.829 33.057,301.682 33.057,504.396  66.512,504.396 66.512,301.682 147.11,301.682 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 364.889,
  y: 275.831,
  style: {
    fill: "#E7ECEF"
  },
  width: 114.049,
  height: 228.565
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#D2D6D8"
  },
  points: "478.944,275.829 398.346,275.829 364.89,275.829 364.89,301.682 364.89,504.396  398.346,504.396 398.346,301.682 478.944,301.682 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#B8C1C8"
  },
  points: "119.938,218.22 119.938,247.025 92.365,247.025 92.365,218.22 62.35,218.22 62.35,247.025  34.777,247.025 34.777,218.22 7.604,218.22 7.604,275.829 147.11,275.829 147.11,218.22  "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#B8C1C8"
  },
  points: "477.224,218.22 477.224,247.025 449.651,247.025 449.651,218.22 419.636,218.22  419.636,247.025 392.063,247.025 392.063,218.22 364.89,218.22 364.89,275.829 504.396,275.829 504.396,218.22  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#273340"
  },
  d: "M419.319,313.847L419.319,313.847c-11.758,0-21.29,9.532-21.29,21.29v45.622h42.58v-45.622 C440.609,323.379,431.077,313.847,419.319,313.847z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#273340"
  },
  d: "M87.802,313.847L87.802,313.847c-11.758,0-21.29,9.532-21.29,21.29v45.622h42.58v-45.622 C109.092,323.379,99.561,313.847,87.802,313.847z"
})), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#0083B8"
  },
  points: "256,78.645 156.491,176.985 355.51,176.985 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#037193"
  },
  points: "221.626,176.985 256,78.645 156.491,176.985 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#273340"
  },
  d: "M256,204.863L256,204.863c-11.758,0-21.29,9.532-21.29,21.29v45.622h42.58v-45.622 C277.29,214.395,267.759,204.863,256,204.863z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#273340"
  },
  d: "M256,377.717L256,377.717c-28.555,0-51.704,23.148-51.704,51.704v74.515h103.409v-74.515 C307.705,400.867,284.555,377.717,256,377.717z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFortress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fortress.442ee344.svg";
export { ForwardRef as ReactComponent };